import { useAccountPermitsChecker } from 'Controllers/AccountPermitsChecker/AccountPermitsChecker.helpers';

import { ACCOUNT_PAGE_CATEGORIES, ACCOUNT_SLUGS } from '../AccountPage.consts';

export const useDateFilterInAccountSearchBar = () => {
	const { category, displayDataRangeFilter, slug } = useAccountPermitsChecker();
	const isPagePermittedForDateFilter = displayDataRangeFilter?.();

	const isPurchaseComplete = ACCOUNT_PAGE_CATEGORIES.PURCHASES === category && ACCOUNT_SLUGS.COMPLETE === slug;

	if (isPurchaseComplete) {
		return false;
	}

	return isPagePermittedForDateFilter;
};
